const MAIL_CONFIRMATION = 'MailReceiptModal';
const PRINT_CONFIRMATION = 'PrintReceiptModal';

export const CREATING_ORDER_FLAG = 'CreatingOrder';
export const POST_BOOKING_ORDER_FLAG = 'hasRecentPostBookingOrder';

export const modals = {
  MAIL_CONFIRMATION,
  PRINT_CONFIRMATION,
};
